/**
 * North American display format (e.g. Canada): (514) 555-1234
 * Strips leading 1 if 11 digits.
 * @param {string} raw
 * @returns {string}
 */
export function formatNorthAmericanPhoneInput(raw) {
  if (raw == null) return '';
  let d = String(raw).replace(/\D/g, '');
  if (d.length === 11 && d[0] === '1') d = d.slice(1);
  d = d.slice(0, 10);
  if (d.length === 0) return '';
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

/**
 * Digits only for API / storage (10 digits, drops leading 1).
 * @param {string} formatted
 * @returns {string}
 */
export function phoneDigitsOnly(formatted) {
  let d = String(formatted || '').replace(/\D/g, '');
  if (d.length === 11 && d[0] === '1') d = d.slice(1);
  return d.slice(0, 10);
}
